import InfoMessageBlock from '../InfoMessageBlock.jsx';

const UsageBlock = ({ name, used, max, remainingContent }) => {
    const percent = Math.min(100, parseInt((100 * used) / (max || used * 10)));
    const remaining = max - used;

    return (
        <div className="panel w-full sm:w-1/2 p-6">
            <div className="flex items-center justify-between">
                <div className="text-lg font-medium">{name}</div>
                <div>
                    {used}
                    {!!max && ` of ${max}`}
                </div>
            </div>
            <div className="my-2 rounded-full h-1 w-full bg-gray-300">
                <div
                    className="h-1 bg-primary-700 rounded-full"
                    style={{
                        width: `${percent}%`,
                    }}
                ></div>
            </div>
            
            {!!max && (
                <div
                    className={`${remaining < 0 ? 'text-red-600' : 'text-gray-500'}`}
                >
                    {remaining < 0
                        ? `${Math.abs(remaining)} over the limit`
                        : `${remaining} Remaining`}
                </div>
            )}
            {!!remainingContent && (
                <div className="text-gray-500 text-sm">{remainingContent}</div>
            )}
        </div>
    );
};

const BillingStatus = ({ billingStatusData }) => {
    if (!billingStatusData) {
        return null;
    }

    // For free plans, show combined usage for emails+texts since they share the 100 limit
    const isFree = billingStatusData?.isFree;
    const totalMessagesUsed = (billingStatusData?.numEmails || 0) + (billingStatusData?.numTexts || 0);

    // Texts over the plan's allowance are charged at the overage rate on the next invoice
    const textOverageCost =
        (billingStatusData?.textOverage || 0) * (billingStatusData?.smsOveragePrice || 0);

    return (
        <div className="mb-6">
            <div className="panel-label">Past Month Usage</div>

            <div className="flex flex-wrap sm:flex-nowrap gap-4">
                {isFree ? (
                    <UsageBlock
                        name="Emails & Texts"
                        used={totalMessagesUsed}
                        max={billingStatusData?.maxEmails}
                    />
                ) : (
                    <>
                        <UsageBlock
                            name="Emails"
                            used={billingStatusData?.numEmails}
                            max={billingStatusData?.maxEmails}
                        />
                        <UsageBlock
                            name="Texts"
                            used={billingStatusData?.numTexts}
                            max={billingStatusData?.maxTexts}
                            remainingContent={
                                !billingStatusData?.maxTexts
                                    ? 'Unlimited'
                                    : textOverageCost > 0
                                      ? `$${textOverageCost.toFixed(2)} will be added to your next bill`
                                      : null
                            }
                        />
                    </>
                )}
                {!!billingStatusData?.maxClients && (
                    <UsageBlock
                        name="Clients"
                        used={billingStatusData?.clients}
                        max={billingStatusData?.maxClients}
                    />
                )}
                {!billingStatusData?.maxClients && billingStatusData?.plan !== 'enterprise' && (
                    <UsageBlock
                        name="Users"
                        used={billingStatusData?.users}
                        remainingContent={`$7/user x ${billingStatusData?.users} = $${parseFloat(7 * billingStatusData?.users).toFixed(2)}/month`}
                    />
                )}
            </div>
        </div>
        // <InfoMessageBlock className="mt-4 max-w-2xl">
        //     In the past month you used:
        //     <div>
        //         <span>{billingStatusData?.flows} {billingStatusData?.isFree ? 'emails' : 'text/emails'} sent (of {billingStatusData?.maxFlows} max)</span>
        //     </div>
        //     {!!billingStatusData?.maxClients && (
        //         <div className="mt-0">
        //             {billingStatusData?.clients} of {billingStatusData?.maxClients} clients
        //         </div>
        //     )}
        //     <div className="mt-0">
        //         You currently have {billingStatusData?.users} billable user{billingStatusData?.users !== 1 ? 's' : ''}.
        //     </div>
        // </InfoMessageBlock>
    );
};

export default BillingStatus;
